
export default ()=>{

    const getLocalStorageItem = (key: string): string | null=>{
         return localStorage.getItem(key)
    }

    const setLocalStorageItem = (key: string, value: any)=>{
         localStorage.setItem(key, JSON.stringify(value))
   }
      return {getLocalStorageItem, setLocalStorageItem}
}